import { LOAD_LIST_USER_LOG } from '../actionTypes';

const initialState = {
    userLogList: [],
    totalCount: 0,
    limit: 10,
    offset: 0,
    loading: false,
    error: '',
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_USER_LOG: {
            const { result, totalCount, limit, offset } = action.payload;
            return {
                ...state,
                userLogList: result,
                totalCount,
                limit, 
                offset
            }
        }

        default:
            return state
    }
}